import { Component } from "react";
import { connect } from "react-redux";
import { reEdit } from "../../../redux/absences/absencesEditionActions";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import Icon from "@mui/material/Icon/Icon";
import Fab from "@mui/material/Fab";
import FooterFixedOnScreen from "../../../containers/Layout/FooterFixedOnScreen";

class CancelledAbsence extends Component {
    reEdit() {
        this.props.reEdit(this.props.absences, this.props.activeUser);
    }

    render() {
        return (
            <FooterFixedOnScreen>
                <div className="offset-lg-9 col-lg-3 offset-md-8 col-md-4 offset-sm-6 col-sm-6 offset-6 col-6">
                    <Fab onClick={this.reEdit.bind(this)} className=" red-button div-center">
                        <Icon>save</Icon>
                    </Fab>
                    <span className="floating-btn-text span-center">Remettre en brouillon</span>
                </div>
            </FooterFixedOnScreen>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        absences: state.absences,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        reEdit: (absencesState, activeUser) => dispatch(reEdit(absencesState, activeUser)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(CancelledAbsence);
